import { axiosInstance } from "utils";

interface SDFConnectionPayload {
  clientId: string;
  userName: string;
  password: string;
  client: string;
}

export const createSDFConnection = (payload: SDFConnectionPayload) =>
  axiosInstance.post("/connection/sdf", payload); 